/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Form } from 'reactstrap';

interface SearchableTableSearchProps {
    count: number;
    searchString: string;
    onSearch: (s: string) => void;
    placeholder?:string;
}

interface SearchableTableSearchState {
    searchString: string;
}

export class SearchableTableSearch extends React.Component<SearchableTableSearchProps, SearchableTableSearchState> {
    constructor(props: SearchableTableSearchProps) {
        super(props);
        this.state = { searchString: this.props.searchString };

        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSearchChange(event: React.FormEvent<HTMLInputElement>) {
        this.setState({ searchString: event.currentTarget.value }, () => this.props.onSearch(this.state.searchString));
    }

    render() {
        return (
            <Form >
                <div className="d-flex">
                    <div className="d-flex d-flex-row d-nowrap align-items-center">
                        <div className="">
                            <input
                                id="searchField"
                                type="text"
                                className="form-control"
                                placeholder={ this.props.placeholder !== undefined ? this.props.placeholder : "Suche" }
                                value={this.state.searchString}
                                onChange={this.handleSearchChange}
                            />
                        </div>
                        <div className="ms-1 d-none d-md-block">({this.props.count})</div>
                    </div>
                </div>
            </Form>
        );
    }
}
